"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorRateGraph = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const ErrorRateGraphStyled = styled_components_1.default.div `
	flex-shrink: 0;
	position: relative;
	${props => (props.$isDesktop ? 'width: 100%;' : 'width: auto;')}
	margin-top: 45px;
	margin-bottom: ${props => (props.$isMobile ? '30px' : 'unset')};
	flex: 1;

	.bar-graph-wrap {
		display: flex;
		height: 100%;
		width: 100%;
		padding-bottom: 20px;

		.frame-001 {
			display: flex;
			flex-direction: column-reverse;
			height: 100%;
			align-items: flex-start;
			justify-content: space-between;
			width: 20px;
		}
	}

	.bar-graph {
		display: flex;

		flex: 1;
	}

	&.vertical {
		.bar-graph {
			flex-direction: column;
			align-items: flex-start;
			justify-content: space-evenly;
		}

		.bar {
			border-radius: 8px;
			height: 36px;
			margin-left: 42px;
			display: flex;
			flex-direction: row-reverse;
		}

		.bottom_label {
			position: absolute;
			left: -42px;
		}

		.label {
			background: var(--natural-color-n-100, #ffffff);
			border-radius: 6px;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px;
			padding: 6px 4px 6px 4px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			margin: 5px;
			left: 50px;
			box-shadow: 0px 2px 4px 0px rgba(240, 240, 240, 1);
		}
	}

	&.horizontal {
		.bar-graph {
			align-items: flex-end;
			justify-content: space-evenly;
		}

		.label {
			background: var(--natural-color-n-100, #ffffff);
			border-radius: 5px;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px;
			padding: 0px 4px 0px 4px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			margin-top: -31px;
			box-shadow: 0px 2px 4px 0px rgba(240, 240, 240, 1);
		}

		.bar {
			border-radius: 8px 8px 0px 0px;
			width: 36px;
		}

		.bottom_label {
			position: absolute;
			bottom: -40px;
			transform: translate(-50%, -50%);
			left: 50%;
		}
	}

	.bar {
		position: relative;
		box-shadow: 4px 0px 10px 0px rgba(247, 197, 209, 0.5);
	}

	.label {
		align-items: center;
		justify-content: center;
		position: relative;
		color: var(--tur-p, #2d39aa);
		text-align: center;
		font-family: var(--b6-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b6-font-size, 10px);
		line-height: var(--b6-line-height, 20px);
		font-weight: var(--b6-font-weight, 400);
	}

	.txt {
		color: var(--color-grey, #666666);
		text-align: center;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: ${props => (props.$isMobile ? '12px' : 'var(--b4-font-size, 14px)')};
		line-height: var(--b4-line-height, 28px);
		font-weight: var(--b4-font-weight, 400);
		width: 38px;
	}
`;
const color_list = ['#f46790', '#f38fac', '#f1b4c6', '#f4cdd8', '#fbe0e7'];
exports.ErrorRateGraph = react_1.default.memo(({ isVertical, hardest, width, height, }) => {
    const [data, setData] = react_1.default.useState([]);
    const { isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    (0, react_1.useEffect)(() => {
        const best5 = hardest.slice(0, 5);
        let list = [];
        best5.map(item => {
            list.push({
                label: item.number.toString() + '번',
                value: item.incorrect_rate.toFixed(1) + '%',
                height: isVertical ? '36px' : `${((height - 20) * item.incorrect_rate) / 100}px`,
                width: isVertical ? `${(width * item.incorrect_rate) / 100}px` : '36px',
            });
        });
        setData(list);
    }, [hardest]);
    return (react_1.default.createElement(ErrorRateGraphStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile, className: `${isVertical ? 'vertical' : 'horizontal'}`, style: { minWidth: isMobile ? 'unset' : `${width}px`, height: `${height}px` } },
        react_1.default.createElement(BarGraph, { isVertical: isVertical, color_list: color_list, data: data })));
});
const BarGraph = ({ isVertical, color_list, data, }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "bar-graph-wrap" },
            !isVertical && (react_1.default.createElement("div", { className: "frame-001" },
                react_1.default.createElement("span", { className: "txt" }, " 0"),
                react_1.default.createElement("span", { className: "txt" }, " 50"),
                react_1.default.createElement("span", { className: "txt" }, " 100"))),
            react_1.default.createElement("div", { className: "bar-graph", style: { flexDirection: `${isVertical ? 'column' : 'row'}` } }, data.map((item, index) => (react_1.default.createElement("div", { className: "bar", key: index, style: {
                    height: `${item.height}`,
                    width: `${item.width}`,
                    background: `${color_list[index]}`,
                } },
                react_1.default.createElement("span", { className: "label" }, item.value),
                react_1.default.createElement("div", { className: "txt bottom_label" }, item.label))))))));
};
